/* EE 2026-06-16 — TrustedShops/eTrusted Mini-Stars Lazy-Mount (Bug Mi1), robuste v2.
   <etrusted-widget> wird erst gerendert, wenn die Karte (nahezu) im Viewport ist.
   Mehrere Trigger, damit above-the-fold-Sterne IMMER sofort erscheinen, auch wenn
   IntersectionObserver gedrosselt ist (Hintergrund-Tab, bfcache, Prerender): initialer
   Eager-Pass via getBoundingClientRect + Scroll/Resize-Fallback + IO fuers Nachladen. */
(function () {
  var SEL = '.ee-ts-stars[data-ts-gtin]';
  var MARGIN = 300;
  function mount(el) {
    if (el.dataset.tsMounted) return;
    el.dataset.tsMounted = '1';
    var w = document.createElement('etrusted-widget');
    w.setAttribute('data-etrusted-widget-id', el.getAttribute('data-ts-widget-id'));
    w.setAttribute('data-gtin', el.getAttribute('data-ts-gtin'));
    el.appendChild(w);
  }
  function near(el) {
    var b = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return b.bottom >= -MARGIN && b.top <= vh + MARGIN;
  }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); mount(e.target); } });
  }, { rootMargin: MARGIN + 'px 0px' }) : null;
  function process(el) {
    if (el.dataset.tsMounted) return;
    if (near(el)) { mount(el); if (io) io.unobserve(el); }
    else if (io) io.observe(el);
  }
  function scan(root) { (root || document).querySelectorAll(SEL).forEach(process); }
  function init() { scan(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('load', function () { scan(); });
  window.addEventListener('pageshow', function () { scan(); });
  /* Scroll/Resize-Fallback (falls IO gedrosselt): nahe Platzhalter mounten */
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      ticking = false;
      var list = document.querySelectorAll(SEL);
      for (var i = 0; i < list.length; i++) { if (!list[i].dataset.tsMounted && near(list[i])) mount(list[i]); }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  /* AJAX-nachgeladene Karten (Collection-Filter/Sort/Pagination) */
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (!m.addedNodes) return;
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches(SEL)) process(n);
          else if (n.querySelectorAll) scan(n);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();